import Card from "components/card/Card"
import {Spinner, Text} from "@chakra-ui/react";
import {gql, useQuery} from "@apollo/client";
import React, {useState} from "react";
import {AgGridReact} from 'ag-grid-react';

import 'ag-grid-community/styles//ag-grid.css';
import 'ag-grid-community/styles//ag-theme-alpine.css';

const analyzeAspectsQuery = gql`
    query AnalyzeAspectsQuery($aspect_name: String, $customer_name: String) {
      analyze_aspects_query(args: {aspect_name: $aspect_name, customer_name: $customer_name}) {
        brand
        count
        name
        product_platform_id
        sentiment
        product_family
        reviews_count
      }
    }
`

function AspectAgGrid({series, setProductFamilyClicked, setSentimentClicked, onOpen}) {

    function cellClicked(event) {
        if (['positives', 'negatives', 'neutral'].includes(event.colDef.field)) {
            if (event.colDef.field === "positives") {
                setSentimentClicked("positive")
            } else if (event.colDef.field === "negatives") {
                setSentimentClicked("negative")
            } else {
                setSentimentClicked("neutral")
            }
            setProductFamilyClicked(event.data.productFamilyName)
            onOpen()
        }

    }

    const [columnDefs] = useState([
        {field: 'productFamilyName', sortable: true, width: 400},
        {field: 'brand', sortable: true},
        {
            field: 'totalReviews', sortable: true, filter: 'agNumberColumnFilter',
            filterParams: {
                buttons: ['apply', 'reset'],
                closeOnApply: true,
            },
        },
        {
            field: 'positives', sortable: true, filter: 'agNumberColumnFilter',
            filterParams: {
                buttons: ['apply', 'reset'],
                closeOnApply: true,
            },
        },
        {
            field: 'negatives', sortable: true, filter: 'agNumberColumnFilter',
            filterParams: {
                buttons: ['apply', 'reset'],
                closeOnApply: true,
            },
        },
        {
            field: 'neutral', sortable: true, filter: 'agNumberColumnFilter',
            filterParams: {
                buttons: ['apply', 'reset'],
                closeOnApply: true,
            },
        },
        {
            field: '%Negative', sortable: true, filter: 'agNumberColumnFilter',
            sort: 'desc',
            filterParams: {
                buttons: ['apply', 'reset'],
                closeOnApply: true,
            },
        },
    ]);
    return (
        <div className="ag-theme-alpine" style={{height: 780, width: '100%', "--ag-borders": "none"}}>
            <AgGridReact rowData={series} columnDefs={columnDefs}
                         onCellClicked={(event) => cellClicked(event)}></AgGridReact>
        </div>
    )
}

export default function AspectAnalysisGrid({aspect, setProductFamilyClicked, setSentimentClicked, onOpen}) {

    let {loading, error, data} = useQuery(analyzeAspectsQuery,
        {variables: {"aspect_name": aspect, "customer_name": localStorage.getItem("customerName")}})
    if (loading) return <Card><Spinner/></Card>
    if (error) return <Text>Error loading data, please try again!</Text>

    let counts = {}
    let productPlatformIdSet = new Set();
    for (let row of data.analyze_aspects_query) {
        counts[row.brand] = counts[row.brand] ?? {}
        counts[row.brand][row.product_family] = counts[row.brand][row.product_family] ?? {}
        // counts[row.brand][row.product_platform_id][row.name] = counts[row.brand][row.product_platform_id][row.name] ?? {}
        if (!('positive' in counts[row.brand][row.product_family])) {
            counts[row.brand][row.product_family]['positive'] = 0
        }
        if (!('negative' in counts[row.brand][row.product_family])) {
            counts[row.brand][row.product_family]['negative'] = 0
        }
        if (!('neutral' in counts[row.brand][row.product_family])) {
            counts[row.brand][row.product_family]['neutral'] = 0
        }
        counts[row.brand][row.product_family][row.sentiment] += row.count
        if (!productPlatformIdSet.has(row.product_platform_id)) {
            // Reviews count is duplicated, only add it once per product_platform_id
            if (!('total_reviews_count' in counts[row.brand][row.product_family])) {
                counts[row.brand][row.product_family]['total_reviews_count'] = 0;
            }
            counts[row.brand][row.product_family]['total_reviews_count'] += row.reviews_count;
            productPlatformIdSet.add(row.product_platform_id);
        }
    }
    let series = []
    for (let brand in counts) {
        for (let product_family in counts[brand]) {

            let series_obj = {
                productFamilyName: product_family,
                brand: brand,
                positives: counts[brand][product_family].positive,
                negatives: counts[brand][product_family].negative ?? 0,
                neutral: counts[brand][product_family].neutral ?? 0,
                totalReviews: counts[brand][product_family].total_reviews_count ?? 0
            }
            series_obj['%Negative'] = Number((series_obj.negatives * 100.0 /
                (series_obj.negatives + series_obj.positives + series_obj.neutral)).toFixed(1))
            series.push(series_obj)

        }
    }

    return (
        <Card>
            <AspectAgGrid series={series} setProductFamilyClicked={setProductFamilyClicked}
                          setSentimentClicked={setSentimentClicked} onOpen={onOpen}/>
        </Card>
    )

}